import script from "./AdvertiserData.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertiserData.vue?vue&type=script&setup=true&lang=js"

import "./AdvertiserData.vue?vue&type=style&index=0&id=6116ae4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6116ae4a"]])

export default __exports__